import theme from '@/libs/theme';

export const indoorColor = theme.warningColor;

export const outdoorColor = theme.primaryColor;
